import React, { useState } from "react"
import Image from "@yumgmbh/gatsby-theme-yum-components/src/components/atoms/Image"
import Button from "@yumgmbh/gatsby-theme-yum-components/src/components/atoms/Button"

import TeamCard from "@yumgmbh/gatsby-theme-yum-components/src/components/molecules/TeamCard"

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  faTimes,
  faMemoCircleInfo,
  faCalendar,
  faLocationDot,
} from "@fortawesome/pro-solid-svg-icons"
import Richtext from "@yumgmbh/gatsby-theme-yum-components/src/components/atoms/Richtext"

const ScrollContactBlock = ({
  block,
  maincontact,
  contacts,
  buttons,
  title,
  date,
  location,
  text,
}) => {
  const [contactOpenState, setContactOpenState] = useState(false)

  const contactOpenHandler = () => {
    if (contactOpenState === false) {
      setContactOpenState(true)
    } else {
      setContactOpenState(false)
    }
  }

  return (
    <>
      <section
        className={`fixed bottom-0 border-primary border-t-2 left-0 right-0 z-40 transition-all duration-500 transform ${
          contactOpenState === true ? "" : "translate-y-full"
        } bg-white`}
      >
        <div className="py-block block-w-container">
          <div className="flex flex-row flex-wrap -mx-grid">
            <div className="w-full mb-4 md:w-1/2 lg:w-3/4 px-grid">
              {typeof window !== "undefined" && window.storyblok?.inEditor && (
                <span className="block px-4 py-2 font-bold text-red-500 border border-red-400 ">
                  In der Storyblok-Vorschau sind die Personen-Daten nicht
                  verfügbar und können deshalb nicht dargestellt werden.
                </span>
              )}
              <div className="flex flex-wrap fley-row -mx-grid">
                {maincontact?.content && (
                  <div className="w-full lg:w-1/3 px-grid">
                    <TeamCard item={maincontact?.content} />
                  </div>
                )}

                {contacts?.length > 0 &&
                  contacts.map((item, index) => (
                    <div className="w-full lg:w-1/3 px-grid" key={index}>
                      <TeamCard item={item?.content} />
                    </div>
                  ))}
              </div>
            </div>
            <div className="w-full lg:w-1/4 px-grid">
              <div className="block w-full pt-4 border-t-2 lg:pt-0 border-primary lg:border-t-0">
                {title?.length > 0 && (
                  <span className="block font-semibold">{title}</span>
                )}
                {date?.length > 0 && (
                  <span className="mr-4 text-sm">
                    <FontAwesomeIcon
                      icon={faCalendar}
                      size="1x"
                      className="mr-2"
                    />
                    {date}
                  </span>
                )}
                {location?.length > 0 && (
                  <span className="text-sm">
                    <FontAwesomeIcon
                      icon={faLocationDot}
                      size="1x"
                      className="mr-1"
                    />
                    {location}
                  </span>
                )}
                {text?.length > 0 && <Richtext text={text} />}
                {buttons?.map((button, index) => (
                  <div
                    key={index}
                    className="block md:inline-block md:mr-4 lg:mr-0 lg:block"
                  >
                    <Button
                      className="mt-4"
                      btnType={index > 0 ? "secondary" : "primary"}
                      link={button.link}
                      target={button.target}
                      key={index}
                      icon={button.icon}
                    >
                      {button.link_text}
                    </Button>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="fixed bottom-0 right-0 z-50 inline-block p-4">
        <button
          className="w-12 h-12 px-2 py-2 rounded-full btn btn-primary"
          onClick={() => contactOpenHandler()}
        >
          <span className="mx-auto ">
            {contactOpenState === false ? (
              <FontAwesomeIcon
                icon={faMemoCircleInfo}
                size="lg"
                className="mb-0.25"
              />
            ) : (
              <FontAwesomeIcon icon={faTimes} size="lg" className="mb-0.25" />
            )}
          </span>
        </button>
      </div>
    </>
  )
}

export default ScrollContactBlock
